import { render, staticRenderFns } from "./HomeworkVideo.vue?vue&type=template&id=2e3dce8c&scoped=true"
import script from "./HomeworkVideo.vue?vue&type=script&lang=js"
export * from "./HomeworkVideo.vue?vue&type=script&lang=js"
import style0 from "./HomeworkVideo.vue?vue&type=style&index=0&id=2e3dce8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3dce8c",
  null
  
)

export default component.exports